import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Card,
  Button,
  Empty,
  Select,
  Typography,
  Divider,
  Statistic,
  message,
} from 'antd';
import {
  GlobalOutlined,
  ApiOutlined,
  LineChartOutlined,
  ArrowRightOutlined,
  ProfileOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './Overview.scss';

import {
	userUpdateSelectedHostname,
} from '../../modules/user';
import {
	shortenLinkList,
} from '../../modules/shortenLink';



const { Title, Paragraph, Text } = Typography;
const { Option } = Select;


import {
	userLogin
} from '../../modules/user';

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hostnames: [],
      loading: true,
      selectedHostname: this.props.selectedHostname || null,
      stats: {
        endpoints: 0,
        rules: 0,
        trafficPatterns: 0,
        activeEndpoints: 0
      }
    };
  }

  componentDidMount = async () => {
    const { hostnames, endpoints } = this.props;
    const { selectedHostname } = this.state; 
    if (hostnames.length <= 0) {

      this.props.shortenLinkList().then(res => {
        this.fetchHostnames(res);
      }).catch(error => {
        message.error('Failed to fetch domains');
        this.setState({ loading: false });
      });
    } else {
      this.fetchHostnames(hostnames);
    }

    if (endpoints.length <= 0) {
      this.props.endpointList().then(res => {
        this.fetchStats(res);
      }).catch(error => {
        message.error('Failed to fetch endpoint');
        this.setState({ loading: false });
      });
    } else {
      this.fetchStats(endpoints);
    }

    this.props.ruleList({hostname: this.props.selectedHostname?.hostname}).then(res => {
      this.setState({
        rules: res.length,
      });
    }).catch(error => {
      message.error('Failed to fetch rules');
      this.setState({ loading: false });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedHostname?.id !== this.props.selectedHostname?.id) {
      this.setState({ selectedHostname: this.props.selectedHostname });
      this.fetchStats(this.props.endpoints);
    }
  }

  fetchHostnames = (hostnames) => {
      // const hostnames = [
      //   { id: 1, hostname: 'example.com', enabled: true, createdAt: '2023-05-10' },
      //   { id: 2, hostname: 'test-api.example.org', enabled: false, createdAt: '2023-06-15' },
      //   { id: 3, hostname: 'dev.myapp.com', enabled: true, createdAt: '2023-07-22' },
      // ];
      this.setState({
        hostnames: hostnames,
        loading: false,
        selectedHostname: hostnames[0]
      }, () => {
        // update global state, let other component know the selected hostname
        if (this.props.userUpdateSelectedHostname) {
          this.props.userUpdateSelectedHostname(hostnames[0]);
        }

        // this.fetchStats(hostnames[0].id);
      });
  }

  fetchStats = (endpoints) => {
    if (!endpoints) {
      return;
    }
    const stats = {
      endpoints: endpoints?.length,
      activeEndpoints: endpoints?.filter(e => e.status === 'active')?.length
    };

    this.setState({ stats: stats })
  }

  handleHostnameChange = (value) => {
    const selectedHostname = this.state.hostnames.find(h => h.id === value);
    this.setState({ selectedHostname });

    // update global state
    if (this.props.userUpdateSelectedHostname) {
      this.props.userUpdateSelectedHostname(selectedHostname);
    }

    this.fetchStats(this.props.endpoints);
  }

  render() {
    const { hostnames, loading, selectedHostname, stats } = this.state;

    return (
      <div className="overview-container">
        <Card className="overview-card" loading={loading}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
             <div className="overview-title">
                <GlobalOutlined className="overview-icon" />
                <h2>Domain Overview</h2>
              </div>
              <Paragraph className="subtitle">
                Select a domain to manage its endpoints and traffic patterns
              </Paragraph>
            </Col>

            <Col span={24}>
              <div className="hostname-selector">
                <Text strong>Selected Domain:</Text>
                <Select
                  style={{ width: 300, marginLeft: 16 }}
                  placeholder="Select a domain"
                  onChange={this.handleHostnameChange}
                  value={selectedHostname ? selectedHostname.id : undefined}
                  loading={loading}
                >
                  {hostnames.map(host => (
                    <Option key={host.id} value={host.id}>
                      {host.hostname}
                      {!host.enabled && <Text type="secondary"> (disabled)</Text>}
                    </Option>
                  ))}
                </Select>
                <Button
                  type="link"
                  icon={<GlobalOutlined />}
                  href="/domain"
                >
                  Manage Domains
                </Button>
              </div>
            </Col>
          </Row>

          {selectedHostname ? (
            <>
              <Divider />

              <Row gutter={[24, 24]}>
                <Col span={24}>
                  <Title level={4}>
                    {selectedHostname.hostname}
                    {!selectedHostname.enabled && <Text type="secondary"> (disabled)</Text>}
                  </Title>
                </Col>


                <Col xs={24} sm={12} md={8}>
                  <Card className="stat-card">
                    <Statistic
                      title="Total Rules"
                      value={stats.endpoints}
                      prefix={<ProfileOutlined />}
                    />
                    <Divider />
                    <Link to={`/rule/${selectedHostname.id}`}>
                      <Button type="primary" block>
                        Manage Rules <ArrowRightOutlined />
                      </Button>
                    </Link>
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <Empty
              description="Please select a domain"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
	selectedHostname: state.user.selectedHostname,
  hostnames: state.hostname.hostnames
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    userUpdateSelectedHostname,
    shortenLinkList,
    userLogin,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
